/*
 *
 * Questionnaires constants
 *
 */

export const SLICE_NAME = 'questionnaires';
